import * as PricebooksActions from "./pricebooksActions";

export default PricebooksActions;



// WEBPACK FOOTER //
// ./src/actions/PricebooksActions/index.js